// Copyright (c) 2017 Deere & Company

export const canGetProductCustomer = product => product.customerSummary.id;

const allowedValueForPrivacyRules = rule => ({
    cmInvoiceRequestNotAllowed: false,
    customerPrivate: false,
    laborStatsNotAllowed: false,
    registrationFormNotAllowed: false,
    registrationNotAllowed: false,
    showWaitingForDealerInvoice: true
})[rule];

export const hasPermission = (privacy, rule) => privacy[rule] === allowedValueForPrivacyRules(rule);



// WEBPACK FOOTER //
// ./src/shared/services/privacy.js